<template>
  <div class="discpiption-tag-refer">
    <div class="discpiption-tag-refer-title-box">
      <h3 class="flex1 width-0">{{ props.title }}</h3>
      <div
        class="discpiption-tag-refer-switch flex-center"
        v-show="
          !(renderData.disabledSwichFirst && renderData.disabledSwichLast)
        "
      >
        <div
          class="discpiption-tag-refer-switch-item discpiption-tag-refer-switch-left"
        >
          <IconButton
            size="24px"
            icoSize="12px"
            backgroundColor="rgba(255, 255, 255, 0.1)"
            hoverBackgroundColor="rgba(255, 255, 255, 0.2)"
            :disabled="renderData.disabledSwichFirst"
            @onClick="changePrev"
          >
            <img src="@/assets/img/content/prev.png" alt="" />
          </IconButton>
        </div>
        <div
          class="discpiption-tag-refer-switch-item discpiption-tag-refer-switch-right"
        >
          <IconButton
            size="24px"
            icoSize="12px"
            backgroundColor="rgba(255, 255, 255, 0.1)"
            hoverBackgroundColor="rgba(255, 255, 255, 0.2)"
            :disabled="renderData.disabledSwichLast"
            @onClick="changeNext"
          >
            <img src="@/assets/img/content/next.png" alt="" />
          </IconButton>
        </div>
      </div>
    </div>
    <div class="discpiption-tag-refer-tags">
      <div class="swiper" ref="refStyleSwiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in props.tagList"
            :key="index + 1"
          >
            <div
              class="swiper-tag-item pointer"
              :class="{
                'swiper-tag-item-disabled': hasSelectedTag(item.tag),
                'swiper-tag-party': item.is_top,
              }"
              @click="() => onReferTagSelect(item)"
            >
              <span class="block omlh-2 tc"> {{ item.tag }}</span>
              <i class="block"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue"

import { useRouter, useRoute } from "vue-router"

import Swiper from "swiper"
import "swiper/css"
import IconButton from "@/components/basic/button/IconButton.vue"
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js"
import apiReferMusic from "@/api/api/apiReferMusic.js"
import { storeToRefs } from "pinia"
import useCreateLayoutStore from "@/store/create/createLayoutStore.js"
const createLayoutStore = useCreateLayoutStore()

const { createRenderType } = storeToRefs(createLayoutStore)

const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.()))
  .appContext?.config?.globalProperties?.$router
const route = useRoute()
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const refStyleSwiper = ref(null)
const swiperInstance = ref(null)

const props = defineProps({
  tagList: {
    type: Array,
    default: () => {
      return Array.from({ length: 20 }, (_, index) => {
        return {
          content: "tag" + index,
          id: index,
        }
      })
    },
  },
  title: {
    type: String,
    default: "",
  },
  idea: {
    type: String,
    default: "",
  },
})
const emits = defineEmits([])

const stateData = {
  observeFirst: null,
  observeLast: null,
  separator: $$language() == "cn" ? "，" : ", ",
}

const renderData = reactive({
  swiperActiveIndex: 0,
  disabledSwichFirst: false,
  disabledSwichLast: false,
  styleList: new Array(10).fill(' '),
})

const hasSelectedTag = (tag) => {
  return props.idea
    ?.split(stateData.separator.replace(/\s+/, ""))
    .some((str, idex) => {
      return str.replace(/(^\s+)|(\s+$)/, "") == tag
    })
}

const onSlideChange = (swiper) => {
  renderData.swiperActiveIndex = swiper.activeIndex
  nextTick(() => {
    reinitObserverEvent()
  })
}

const changePrev = () => {
  swiperInstance.value?.slideTo(renderData.swiperActiveIndex - 3)
}

const changeNext = () => {
  swiperInstance.value?.slideTo(renderData.swiperActiveIndex + 3)
}

const initObserverEvent = () => {
  nextTick(() => {
    if (refStyleSwiper.value) {
      setTimeout(() => {
        let els = refStyleSwiper.value?.querySelectorAll(".swiper-slide")
        if (els && els.length >= 1) {
          isElementHalfVisible(els[0], "First")
          isElementHalfVisible(els[props.tagList.length - 1], "Last")
        }
      }, 10)
    }
  })
}

const isElementHalfVisible = (element, type) => {
  stateData[`observe${type}`] = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        renderData[`disabledSwich${type}`] = entry.isIntersecting
      })
    },
    {
      root: null, // 默认为 viewport
      rootMargin: "0px", // 边距
      threshold: Array.from({ length: 101 }, (_, i) => i / 100), // 0.0 到 1.0 的每个步长
    }
  )
  stateData[`observe${type}`].observe(element)
}

const reinitObserverEvent = () => {
  stateData[`observeFirst`]?.disconnect()
  stateData[`observeLast`]?.disconnect()
  initObserverEvent()
}

const onRandomStyle = () => {}

const onReferTagSelect = (item) => {
  emits("referTagSelect", item)
}
watch(
  () => {
    return props.tagList
  },
  () => {
    reinitObserverEvent()
  }
)

onMounted(() => {
  swiperInstance.value = new Swiper(refStyleSwiper.value, {
    slidesPerView: "auto",
    spaceBetween: createRenderType.value === "pc" ? 16 : 8,
    slidesOffsetAfter: createRenderType.value === "pc" ? 16 : 8,
    on: {
      slideChange: onSlideChange,
    },
  })
  nextTick().then(() => {
    reinitObserverEvent()
  })
})

onUnmounted(() => {
  stateData[`observeFirst`]?.disconnect()
  stateData[`observeLast`]?.disconnect()
})
</script>
<style lang="scss">
.discpiption-tag-refer {
  .discpiption-tag-refer-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: #ffffff;
    }
    .discpiption-tag-refer-switch-item {
      margin-left: 12px;
    }
  }
  .discpiption-tag-refer-tags {
    margin: 8px 0 0 0;
    height: 32px;
    .swiper-tag-item {
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 32px;
      text-align: center;
      color: #ffffff;
      height: 32px;
      border-radius: 50px;
      padding: 0;
      background: rgba(255, 255, 255, 0.2);
      padding: 0 16px;
      &:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      &.swiper-tag-item-disabled {
        background: rgb(148, 173, 255, 1);
        &:hover {
          background: rgb(148, 173, 255, 0.75);
        }
      }
      &.swiper-tag-party {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 12px 0 16px;
        background: linear-gradient(
          104deg,
          rgba(121, 152, 255, 0.6) 0%,
          rgba(101, 175, 131, 0.6) 23%,
          rgba(202, 223, 159, 0.6) 49%,
          rgba(229, 132, 224, 0.6) 74%,
          rgba(183, 174, 255, 0.6) 100%
        );
        i {
          height: 16px;
          width: 16px;
          background: url("@/assets/img/party-anthem-ico.png") no-repeat;
          background-size: 100% 100%;
          margin-left: 4px;
        }

        &.swiper-tag-item-disabled {
          background: linear-gradient(
            104deg,
            rgba(121, 152, 255, 1) 0%,
            rgba(101, 175, 131, 1) 23%,
            rgba(202, 223, 159, 1) 49%,
            rgba(229, 132, 224, 1) 74%,
            rgba(183, 174, 255, 1) 100%
          );
        }
        &:hover {
          background: linear-gradient(
            104deg,
            rgba(121, 152, 255, 0.8) 0%,
            rgba(101, 175, 131, 0.8) 23%,
            rgba(202, 223, 159, 0.8) 49%,
            rgba(229, 132, 224, 0.8) 74%,
            rgba(183, 174, 255, 0.8) 100%
          );
        }
      }
    }
    .swiper {
      height: 100%;
      .swiper-wrapper {
        display: flex;
        height: 100%;
      }
      .swiper-slide {
        height: 100%;
        width: max-content;
      }
    }
  }
}
</style>
